function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "shop_svg__a",
  width: "264.3%",
  height: "235.3%",
  x: "-82.1%",
  y: "-67.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 6
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#shop_svg__a)",
  transform: "translate(10 12)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M14 0C7.093 0 1.5 5.712 1.5 12.75c0 4.723 1.562 6.198 9.848 19.75a3.095 3.095 0 005.304 0c8.29-13.559 9.848-15.028 9.848-19.75C26.5 5.704 20.9 0 14 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#adc6ca",
  d: "M8 13a6 6 0 1112 0 6 6 0 01-12 0z"
}));

function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI1NyIgdmlld0JveD0iMCAwIDQ4IDU3Ij4KICAgIDxkZWZzPgogICAgICAgIDxmaWx0ZXIgaWQ9ImxldDNtMTJqdGEiIHdpZHRoPSIyNjQuMyUiIGhlaWdodD0iMjM1LjMlIiB4PSItODIuMSUiIHk9Ii02Ny42JSIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94Ij4KICAgICAgICAgICAgPGZlT2Zmc2V0IGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz4KICAgICAgICAgICAgPGZlR2F1c3NpYW5CbHVyIGluPSJzaGFkb3dPZmZzZXRPdXRlcjEiIHJlc3VsdD0ic2hhZG93Qmx1ck91dGVyMSIgc3RkRGV2aWF0aW9uPSI2Ii8+CiAgICAgICAgICAgIDxmZUNvbG9yTWF0cml4IGluPSJzaGFkb3dCbHVyT3V0ZXIxIiByZXN1bHQ9InNoYWRvd01hdHJpeE91dGVyMSIgdmFsdWVzPSIwIDAgMCAwIDAuMiAwIDAgMCAwIDAuMiAwIDAgMCAwIDAuMiAwIDAgMCAwLjI1IDAiLz4KICAgICAgICAgICAgPGZlTWVyZ2U+CiAgICAgICAgICAgICAgICA8ZmVNZXJnZU5vZGUgaW49InNoYWRvd01hdHJpeE91dGVyMSIvPgogICAgICAgICAgICAgICAgPGZlTWVyZ2VOb2RlIGluPSJTb3VyY2VHcmFwaGljIi8+CiAgICAgICAgICAgIDwvZmVNZXJnZT4KICAgICAgICA8L2ZpbHRlcj4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxnPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPGcgZmlsdGVyPSJ1cmwoI2xldDNtMTJqdGEpIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTEwMyAtNTUyKSB0cmFuc2xhdGUoODAwIDgwKSB0cmFuc2xhdGUoMzAzIDQ3MikgdHJhbnNsYXRlKDEwIDEyKSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE0IDBDNy4wOTMgMCAxLjUgNS43MTIgMS41IDEyLjc1YzAgNC43MjMgMS41NjIgNi4xOTggOS44NDggMTkuNzUgMS4yMjMgMiA0LjA4MiAxLjk5OSA1LjMwNCAwIDguMjktMTMuNTU5IDkuODQ4LTE1LjAyOCA5Ljg0OC0xOS43NUMyNi41IDUuNzA0IDIwLjkgMCAxNCAweiIvPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjYWRjNmNhIiBkPSJNOCAxM2MwLTMuMzE0IDIuNjg2LTYgNi02czYgMi42ODYgNiA2LTIuNjg2IDYtNiA2LTYtMi42ODYtNi02eiIvPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgShop as ReactComponent };